import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-echarts",
  "use": "icon-echarts-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-echarts\"><path d=\"M474.926 74.047a474.901 474.901 0 10474.902 474.901H474.926zM548.923.05v474.901h474.902A474.901 474.901 0 00548.923.201z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol